import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SCLoader, SCSwitch } from 'rollup-allspark';
import { useInjectReducer } from '../../utils/injectReducer';
import { useInjectSaga } from '../../utils/injectSaga';
import reducer from './reducer';
import saga from './saga';
import * as selectors from './selectors';
import KpiStrip from './KpiStrip';
import SectionCard from './components/SectionCard';

/**
 * Overview summary — headline KPI strip with trend badges and an expandable
 * per-channel breakdown (see KpiStrip). The "Channel Summary" switch lives in
 * the section header and drives every KPI card's breakdown at once.
 */
const Summary = ({ summary, analyticsProviders, summaryLoading }) => {
  useInjectReducer({ key: 'nativeAnalytics', reducer });
  useInjectSaga({ key: 'nativeAnalytics', saga });
  const [breakdownOpen, setBreakdownOpen] = useState(false);

  const renderLoader = (
    <div className="flex h-48 w-full items-center justify-center">
      <SCLoader lineWidth={5} diameter={50} />
    </div>
  );

  const channelToggle = (
    <div className="flex items-center gap-x-2">
      <span className="text-sm font-medium text-grey-darker">
        Channel Summary
      </span>
      <SCSwitch value={breakdownOpen} handleChange={v => setBreakdownOpen(v)} />
    </div>
  );

  return (
    <SectionCard
      title="Summary"
      actions={summaryLoading ? null : channelToggle}
    >
      {summaryLoading ? (
        renderLoader
      ) : (
        <KpiStrip
          summary={summary}
          providers={analyticsProviders}
          breakdownOpen={breakdownOpen}
          onBreakdownToggle={setBreakdownOpen}
        />
      )}
    </SectionCard>
  );
};

Summary.propTypes = {
  summary: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  analyticsProviders: PropTypes.array,
  summaryLoading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  summary: selectors.makeSelectSummary(),
  analyticsProviders: selectors.makeSelectAnalyticsProviders(),
  summaryLoading: selectors.makeSelectSummaryLoading(),
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(Summary);
